import { Dialog, Transition } from '@headlessui/react'
import { ExclamationIcon } from '@heroicons/react/outline'
import axios from 'axios'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { getAllReports } from '../../../../Redux/actions'


function BottonAdminReports({ data, isSettled }) {

    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const cancelButtonRef = useRef(null)

    const handleClick = () => {
        axios.put(`/report/${data.id}`, { isSettled: !isSettled })
        dispatch(getAllReports())
        setOpen(false)
        alert("El estado del reporte cambio")
    }

    useEffect(() => {
        dispatch(getAllReports())
    }, [dispatch])
    return (
        <>
            {
                open ?
                    <Transition.Root show={open} as={Fragment}>
                        <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setOpen}>
                            <div className="flex items-end justify-center h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                                </Transition.Child>

                                {/* This element is to trick the browser into centering the modal contents. */}
                                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                                    &#8203;
                                </span>

                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                            <div className="sm:flex sm:items-start">
                                                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                    <ExclamationIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                                                </div>
                                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                                        Datos del Reporte
                                                    </Dialog.Title>
                                                    <div className="mt-2">
                                                        <label className="font-bold"> Nombre del reporte:</label>
                                                        <p className="text-sm text-gray-500">
                                                            {data?.complaint}
                                                        </p>
                                                    </div>

                                                    <div className="mt-2">
                                                        <label className="font-bold"> Tipo de reporte:</label>
                                                        <p className="text-sm text-gray-500">
                                                            {data?.reportSubject}
                                                        </p>
                                                    </div>
                                                    {
                                                        data?.reportSubject === "question" ?
                                                            <div className="mt-2">
                                                                <label className="font-bold"> Pregunta reportada:</label>
                                                                <p className="text-sm text-gray-500">
                                                                    {data?.question.question}
                                                                </p>
                                                                <label className="font-bold"> Usuario que la realizo: </label>
                                                                <Link to={`/profile/${data?.question.user_id}`} className="text-sm text-gray-500 font-bold">
                                                                    {data?.question.user_id}
                                                                </Link>
                                                            </div> :
                                                            data?.reportSubject === "answer" ?
                                                                <div className="mt-2">
                                                                    <label className="font-bold"> Respuesta reportada:</label>
                                                                    <p className="text-sm text-gray-500">
                                                                        {data?.answer.answer}
                                                                    </p>
                                                                    <label className="font-bold"> Id de respuesta :</label>
                                                                    <p className="text-sm text-gray-500">
                                                                        {data?.answer_id}
                                                                    </p>
                                                                </div>
                                                                :
                                                                data?.reportSubject === "post" ?
                                                                    <div className="mt-2">
                                                                        <label className="font-bold"> Titulo del posteo:</label>
                                                                        <p className="text-sm text-gray-500">
                                                                            {data?.post.title}
                                                                        </p>
                                                                        <label className="font-bold"> Id posteo : </label>
                                                                        <Link to={`/post/${data?.post_id}`} className="text-sm text-gray-500 font-bold">
                                                                            {data?.post_id}
                                                                        </Link>
                                                                    </div>
                                                                    :
                                                                    data?.reportSubject === "user" ?
                                                                        <div className="mt-2 flex flex-col">
                                                                            <label className="font-bold"> Nombre del Usuario reportado:</label>
                                                                            <p className="text-sm text-gray-500">
                                                                                {data?.user.fullName}
                                                                            </p>
                                                                            <label className="font-bold mt-2"> Id del usuario : </label>
                                                                            <Link to={`/user/${data?.user.id}`} className="text-sm text-gray-500 font-bold">
                                                                                {data?.user.id}
                                                                            </Link>
                                                                            <label className="font-bold mt-2"> Evidencia :</label>
                                                                            <p className="text-sm text-gray-500">
                                                                                {data?.evidence}
                                                                            </p>
                                                                        </div>
                                                                        :
                                                                        <span></span>


                                                    }


                                                </div>
                                            </div>
                                        </div>
                                        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                            <button
                                                type="button"
                                                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                                onClick={() => handleClick()}
                                            >
                                                Resuelto
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                                onClick={() => setOpen(false)}
                                                ref={cancelButtonRef}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </Transition.Child>


                            </div>
                        </Dialog>
                    </Transition.Root>
                    :
                    <button onClick={() => setOpen(true)}><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    </button>
            }
        </>
    )
}

export default BottonAdminReports
